module.exports = __webpack_public_path__ + "static/media/cw.29e9049e.svg";